import { FAVORITES_LIST_KEY } from 'favorite/constants/constants'
import type { FavoriteProductResponse } from 'favorite/types/types'
import { favoritesCache } from 'favorite/utils/favoritesCache'

export const getCacheFavorites = () =>
	favoritesCache()?.getKeyFromCache<FavoriteProductResponse[]>(
		FAVORITES_LIST_KEY
	)
